import StopWeightCell from './container';

export default StopWeightCell;
